/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M2.75 0C1.2312 0 0 1.2312 0 2.75v14c0 1.5188 1.2312 2.75 2.75 2.75h6a.7243.7243 0 0 0 .0533-.0019C10.1013 22.1634 12.8361 24 16 24c4.4183 0 8-3.5817 8-8 0-4.2504-3.3146-7.7265-7.5-7.9846V2.75C16.5 1.2312 15.2688 0 13.75 0h-11ZM8 16c0 .6906.0875 1.3608.252 2H2.75c-.6904 0-1.25-.5596-1.25-1.25v-14c0-.6904.5596-1.25 1.25-1.25h11c.6904 0 1.25.5596 1.25 1.25v5.3119c-3.9463.492-7 3.8585-7 7.9381ZM4 6a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7A.75.75 0 0 1 4 6Zm.75 4.25a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Zm14.8098 4.2492a.7501.7501 0 0 0-1.1196-.9983L15.4092 16.9l-1.8717-1.9231a.75.75 0 0 0-1.075 1.0462l2.246 2.3077c.4046.4157 1.0769.4011 1.463-.0319l3.3883-3.7997Z"
    clipRule="evenodd"
  />,
  'MenuTestingFilled'
);
